const ATTEMPTS_KEY = 'peatch.chunk-reload-attempts'
const MAX_ATTEMPTS = 3
const FLUSH_DELAY_MS = 500
const INITIAL_LOAD_WINDOW_MS = 10_000

let claimedThisLoad = false
let interceptorArmed = false

function readAttempts(): number {
  try {
    const parsed = Number.parseInt(window.sessionStorage.getItem(ATTEMPTS_KEY) ?? '', 10)
    return Number.isNaN(parsed) ? 0 : parsed
  } catch {
    return MAX_ATTEMPTS
  }
}

function writeAttempts(next: number): boolean {
  try {
    window.sessionStorage.setItem(ATTEMPTS_KEY, String(next))
    return true
  } catch {
    return false
  }
}

const STALE_CHUNK_SIGNATURES = [
  'failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'importing a module script failed',
  'failed to load module script',
]

export function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : ''
  const lowered = message.toLowerCase()
  return STALE_CHUNK_SIGNATURES.some((signature) => lowered.includes(signature))
}

export function claimReloadAttempt(): boolean {
  if (claimedThisLoad) {
    return false
  }
  const attempts = readAttempts()
  if (attempts >= MAX_ATTEMPTS) {
    return false
  }
  if (!writeAttempts(attempts + 1)) {
    return false
  }
  claimedThisLoad = true
  return true
}

function sameOriginHref(event: MouseEvent): string | null {
  if (event.defaultPrevented || event.button !== 0) {
    return null
  }
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return null
  }
  const target = event.target
  if (!(target instanceof Element)) {
    return null
  }
  const anchor = target.closest('a')
  if (!(anchor instanceof HTMLAnchorElement) || anchor.hasAttribute('download')) {
    return null
  }
  if (anchor.target && anchor.target !== '_self') {
    return null
  }
  const href = anchor.getAttribute('href')
  if (!href || href.startsWith('#')) {
    return null
  }
  const url = new URL(href, window.location.href)
  return url.origin === window.location.origin ? url.href : null
}

export function armFullLoadOnNextNavigation(): void {
  if (interceptorArmed) {
    return
  }
  interceptorArmed = true
  document.addEventListener(
    'click',
    (event) => {
      const href = sameOriginHref(event)
      if (!href) {
        return
      }
      event.preventDefault()
      window.location.assign(href)
    },
    { capture: true }
  )
}

export function installChunkReloadRecovery(): void {
  window.addEventListener('vite:preloadError', () => {
    if (performance.now() > INITIAL_LOAD_WINDOW_MS) {
      armFullLoadOnNextNavigation()
      return
    }
    if (!claimReloadAttempt()) {
      return
    }
    window.setTimeout(() => window.location.reload(), FLUSH_DELAY_MS)
  })
}
